import type { Nullable, ProductEventDataList } from 'corgi-types';

import { ProductEvent } from '../enums/Tracking';
import type { Product } from '../types/product-card';
import { dispatchTrackingEventGA4 } from './dispatchTrackingEventGA4';
import { getProductViewEventData } from './productEventData';

export interface ProductViewTrackingArticle {
  sku: Product['sku'];
  tracking: Partial<Product['tracking']>;
  sponsored?: Product['sponsored'];
  index?: number;
  dyDecisionId?: Nullable<string>;
  dySlotId?: Nullable<string>;
  hasMinPrice?: boolean;
}

export const dispatchProductViewEvent = (
  articles: ProductViewTrackingArticle[],
  productEventDataListType: ProductEventDataList,
  offset: number = 0
) =>
  dispatchTrackingEventGA4({
    event: ProductEvent.View,
    item_list_name: productEventDataListType,
    items: articles.map(({ tracking, index, sponsored, dyDecisionId, dySlotId, hasMinPrice }) =>
      getProductViewEventData({
        list: productEventDataListType,
        position: offset + index,
        tracking,
        sponsored,
        dyDecisionId,
        dySlotId,
        hasMinPrice,
      })
    ),
  });
